<section>
    <!-- <p>Error: {{data.codigo}}</p> -->
    <p>{{data.description}}</p>
    <mat-icon aria-hidden="false" fontIcon="cancel"></mat-icon>
</section>